/**
 * Utility to clean up corrupt activeValues nodes from the graph data
 * This removes any nodes named "activeValues" and ensures the graph structure is correct
 */
export const cleanActiveValuesFromGraph = (graphData) => {
  if (!graphData || typeof graphData !== "object") return graphData;

  const cleanedData = JSON.parse(JSON.stringify(graphData));

  const cleanNode = (node) => {
    if (!node || typeof node !== "object") return;

    // Remove activeValues if it exists as a property (not a node)
    if (node.activeValues && Array.isArray(node.activeValues)) {
      delete node.activeValues;
    }

    // Check all properties
    Object.keys(node).forEach((key) => {
      // If we find an "activeValues" node (not property), remove it
      if (
        key === "activeValues" &&
        typeof node[key] === "object" &&
        !Array.isArray(node[key])
      ) {
        delete node[key];

        // Also remove it from TagAvailableValues if it exists there
        if (node.TagAvailableValues && Array.isArray(node.TagAvailableValues)) {
          node.TagAvailableValues = node.TagAvailableValues.filter(
            (v) => v !== "activeValues",
          );
        }
      } else if (typeof node[key] === "object") {
        // Recursively clean child nodes
        cleanNode(node[key]);
      }
    });
  };

  cleanNode(cleanedData);
  return cleanedData;
};

/**
 * Check if graph data has corrupt activeValues nodes
 */
export const hasCorruptActiveValues = (graphData) => {
  if (!graphData || typeof graphData !== "object") return false;

  let hasCorruption = false;

  const checkNode = (node) => {
    if (!node || typeof node !== "object" || hasCorruption) return;

    Object.keys(node).forEach((key) => {
      // Check for activeValues as a node (not array property)
      if (
        key === "activeValues" &&
        typeof node[key] === "object" &&
        !Array.isArray(node[key])
      ) {
        hasCorruption = true;
        return;
      }

      // Check if activeValues appears in TagAvailableValues
      if (
        node.TagAvailableValues &&
        Array.isArray(node.TagAvailableValues) &&
        node.TagAvailableValues.includes("activeValues")
      ) {
        hasCorruption = true;
        return;
      }

      if (typeof node[key] === "object") {
        checkNode(node[key]);
      }
    });
  };

  checkNode(graphData);
  return hasCorruption;
};
